import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@emotion/react";
import { theme } from "../Theme/theme";
import logo from "../../assets/images/logo_msil.svg";
import HomeIcon from "@mui/icons-material/Home";
import "./index.scss";
import { Box, ClickAwayListener, Divider, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { grey200, white } from "../../config/colors";
import { checkIfAdmin, logOut } from "../../utility/auth";
import { useSelector } from "react-redux";
import { TabContext } from "../Context/TabContext";

function AppLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [pathname, setPathname] = useState("");
  const [showDrop, setShowDrop] = useState(false);

  const userInfo = useSelector((state) => state.user.userInfo);
  const isAdmin = checkIfAdmin(userInfo);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  function handleNavigate() {
    navigate("/home");
  }
  return (
    <ThemeProvider theme={theme}>
      <TabContext.Provider value={{ selectedTab, setSelectedTab }}>
        <div className="app-layout-container">
          {!pathname.includes("login") && (
            <div className="app-navbar">
              <div className="app-navbar-content">
                <img
                  className="app-logo"
                  src={logo}
                  alt=""
                  onClick={handleNavigate}
                />
                <Typography variant="h2" color={white}>
                  Spares Back Order System
                </Typography>

                <Box className="flex-align-center">
                  {
                    <>
                      <HomeIcon
                        sx={{
                          color: white,
                          fontSize: "3.5vh",
                          cursor: "pointer",
                        }}
                        onClick={handleNavigate}
                      />
                    </>
                  }
                  <div className="v-divider" />
                  <ClickAwayListener onClickAway={() => setShowDrop(false)}>
                    <div
                      className="profile-wrapper"
                      onClick={() => setShowDrop(!showDrop)}
                    >
                      {userInfo?.email && (
                        <>
                          <div className="username">
                            {userInfo?.name || "-NA-"}
                          </div>
                          <div className="user-role">
                            {userInfo?.roles || "-NA-"}
                          </div>
                        </>
                      )}
                      {showDrop && (
                        <div className="profile-dropdown">
                          {isAdmin && (
                            <Typography
                              variant="smalltableText"
                              onClick={() => navigate("/user-management")}
                              sx={{
                                width: "100%",
                                padding: "0.8vh 0.95vh",
                                "&:hover": {
                                  background: grey200,
                                },
                              }}
                            >
                              User Management
                            </Typography>
                          )}

                          <Typography
                            variant="smalltableText"
                            onClick={() => navigate("/manual-file-upload")}
                            sx={{
                              width: "100%",
                              padding: "0.8vh 0.95vh",
                              "&:hover": {
                                background: grey200,
                              },
                            }}
                          >
                            Manual File Upload
                          </Typography>

                          <Typography
                            variant="smalltableText"
                            onClick={() => navigate("/customize-home-screen")}
                            sx={{
                              width: "100%",
                              padding: "0.8vh 0.95vh",
                              "&:hover": {
                                background: grey200,
                              },
                            }}
                          >
                            Customise home screen
                          </Typography>

                          <Typography
                            variant="smalltableText"
                            onClick={logOut}
                            sx={{
                              width: "100%",
                              padding: "0.8vh 0.95vh",
                              "&:hover": {
                                background: grey200,
                              },
                            }}
                          >
                            Sign Out
                          </Typography>
                        </div>
                      )}
                    </div>
                  </ClickAwayListener>
                </Box>
              </div>
              <Divider />
            </div>
          )}
          <Box
            sx={{
              height: !pathname.includes("login") ? "92vh" : "100vh",
              marginTop: !pathname.includes("login") ? "7vh" : "0vh",
            }}
            className="app-wrapper"
          >
            {children}
          </Box>
        </div>
      </TabContext.Provider>
    </ThemeProvider>
  );
}

export default AppLayout;
